import type { AccountStorage } from '@/features/billing-usage';
import { useAuth } from '@/services/auth';
import { isFlexPlan } from '@/services/auth/plan-slugs';
import { storedProfileLimit } from '../utils/stored-profile-limit';
import { useWalletUsage } from './use-wallet-usage';

export type FlexStorage =
  | { status: 'loading' }
  | { status: 'unavailable' }
  | { status: 'ready'; storage: AccountStorage };

/**
 * The Flex account's stored people and objects against its stored-profile limit. The count and zone
 * are the ones the backend uses to refuse new profiles. Unavailable off Flex, and for an account
 * without storage limits.
 */
export function useFlexStorage(): FlexStorage {
  const { account } = useAuth();
  const usage = useWalletUsage();

  if (!isFlexPlan(account)) return { status: 'unavailable' };
  if (usage.status === 'loading') return { status: 'loading' };
  if (usage.status === 'error' || usage.storage == null) return { status: 'unavailable' };

  return {
    status: 'ready',
    storage: { stored: usage.storage.stored, limit: storedProfileLimit(account), zone: usage.storage.zone },
  };
}
